<template>
  <div class="header-menu">
    <div class="right-menu clearfix">
      <span class="el-dropdown fl">{{$route.name}}</span>
      <div class="header-rmenu fr">
        <!--从诚云进来-->
        <el-dropdown class="avatar-container" trigger="click" v-if="!thirdParty">
          <div class="avatar-wrapper">
            当前用户：<span>{{companyName}}<i class="jt"></i></span>
          </div>
          <!-- 点击弹出部分 -->
          <el-dropdown-menu slot="dropdown" class="user-dropdown" style="height:500px;overflow:auto;">
            <el-input v-model="searchTxt" placeholder="输入企业名称快速查询" size="small" @input="searchName" class="input-search"></el-input>
            <el-dropdown-item v-for="item in companyList" :key="item.id" @click.native="nameClick(item)">
              {{item.companyName}}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!--第三方登录进来-->
        <div v-else>
          <router-link to='ChangeReg'><button class="login-goResister">修改密码</button></router-link>
          <span class="el-dropdown" @click="logout"><img src="@/assets/login-out.png" class="headImg">退出</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Cookies from 'js-cookie'
    export default {
        name: 'HeadBar',
        components: {
            Cookies
        },
        data() {
            return {
                searchTxt:'',
                companyName:'',
                companyList:'', // 渲染时使用的列表
                companyListBox:[],// 过滤时使用的列表
                thirdParty:sessionStorage.getItem('thirdParty')// 判断是否是从第三方进来的
            };
        },
        methods: {
            //点击公司列表
            nameClick:function(item){
                this.companyName = item.companyName;
                this.$emit('nameClick',item)
            },
            // 退出登录
            logout:function(){
                Cookies.set('token','');
                sessionStorage.removeItem('user');
                sessionStorage.removeItem('thirdParty')
                this.$router.push("/Login")
            },
            // 输入框获取焦点时执行
            searchName:function(){
                let searchTxt = this.searchTxt;
                let companyListBox = [];
                this.companyListBox.forEach(function(item) {
                    let isClud = item.companyName.includes(searchTxt);
                    if(isClud) companyListBox.push(item)
                });
                this.companyList = companyListBox;
            },
        },
        mounted() {
            if (sessionStorage.getItem('thirdParty')) {
                this.$api.login.getUserInfo().then(res => {
                    if (res.status) {
                        sessionStorage.setItem('companyOneId',JSON.stringify(res.data.companyInfoBasic));
                    } else {
                        this.$message({message: '错误提示！' + res.msg, type: 'error'})
                    }
                })
            }else{
                // 诚云进来的
                let companyChange = JSON.parse(sessionStorage.getItem('companyChange')); //切换列表时，将目前公司信息存储起来
                let formData = new FormData();//通过form数据格式来传
                formData.append("makerId", Cookies.get('token'));
                formData.append("source_sys", Cookies.get('source_sys'));
                this.$api.found.findCompanyList(formData).then((res) => {
                    if(res.status){
                        let companyBox = [];
                        res.data.forEach(function(item) {
                            companyBox.push({companyName:item.split(",")[1],id:item.split(",")[0]})
                        });
                        this.companyListBox = companyBox;
                        this.companyList = this.companyListBox;
                        if(companyChange){
                            this.companyName = companyChange.companyName;
                            sessionStorage.setItem('companyOneId',JSON.stringify(companyChange));
                        }else{
                            if(this.companyList.length > 0){
                                // this.nameClick(this.companyList[0]);
                                this.companyName = this.companyList[0].companyName;
                                sessionStorage.setItem('companyOneId',JSON.stringify(this.companyList[0])); // 从诚云登录进来
                            }
                        }
                    }else{
                        this.$message({message: '操作失败, ' + res.msg, type: 'error'})
                    }
                });
            }
        },
    }
</script>

<style>
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .el-header{
    background-color: #fff;
    color: #333;
    text-align: center;
    font-size: 16px;
    padding:0;
  }
  .conent-box{
    padding:20px;
    position: relative;
  }
</style>
<style scoped>
  .fl{
    float:left;
  }
  .fr{
    float:right;
  }
  .clearfix {
    zoom: 1;
  }
  .clearfix:after {
    content: ' ';
    display: block;
    clear: both;
    height: 0;
    visibility: hidden;
  }
  .jt{
    position: absolute;
    right:18px;
    top:-3px;
  }
  .jt::after{
    display: inline-block;
    content: " ";
    height:6px;
    width:6px;
    border-width:2px 2px 0 0;
    border-color: #606266;
    border-style: solid;
    transform: matrix(0.71,0.71,0.71,-0.71, 0, 0);
  }
  .header-menu{
    width:100%;
    line-height: 60px;
    border-bottom:10px solid #f2f7fc;
  }
  .right-menu{
    width:calc(100% - 40px);
    width:-moz-calc(100% - 40px);
    width:-webkit-calc(100% - 40px);
    padding:0 20px;
  }
  .headImg{
    vertical-align:middle;
    width:14px;
    margin-top:-4px;
  }
  .avatar-wrapper{
    display: flex;
    align-items: center;
    margin-right: 30px;
  }
  .avatar-wrapper span{
    color:#2ba5f6;
  }
  .header-rmenu span,button{
    cursor: pointer;
  }
  .input-search{
    margin:0 20px 10px 20px;
    width:calc(100% - 40px);
    width:-webkit-calc(100% - 40px);
    width:-moz-calc(100% - 40px);
  }
  .login-goResister{
    border:none;
    background:inherit;
    font-size:14px;
    color:#2ba5f6;
    margin-right: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/HeadBar.vue